import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-radio-button-list',
  templateUrl: './radio-button-list.component.html',
  styleUrls: ['./radio-button-list.component.scss'],
  imports: [NgClass],
})
export class RadioButtonListComponent {
  @Input() isHorizontalAlignment = false;
}
